<template>
  <v-form v-model="valid" ref="form">
      <div class="form-container px-10">
        <div class="form-group mb-12 text-center">
          <h1>{{title}}</h1>
          <h3 class="form-type">Reset Password</h3>
        </div>
        <div class="form-group">
          <v-text-field
            outlined
            dense
            v-model="newPassword"
            label="New password"
            :rules="[global.rules.required, global.rules.passwordField]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          />
        </div>
        <div class="form-group">
          <v-text-field
            outlined
            dense
            v-model="confirmNewPassword"
            label="Confirm new password"
            :rules="[global.rules.required, global.rules.passwordField]"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"/>
        </div>
        <div class="form-group">
          <v-btn :disabled="!valid" color="primary" :loading="btnLoading" @click="newPasswordOnClick">Confirm</v-btn>
          <v-btn text @click="AuthNavigateTo('gotoLogin')">Cancel</v-btn>
        </div>
      </div>
    </v-form>
</template>

<script>
import AuthPagesMixin from "../mixins/AuthPagesMixin"
import LoginStrings from "../views/Profile/LoginStrings"

export default {
  name: 'ResetPasswordForm',
  mixins: [AuthPagesMixin],
  data() {
    return {
      show: false,
      show2: false,
      newPassword: '',
      confirmNewPassword: '',
      btnLoading: false
    }
  },
  computed: {
    valid(){
      return this.newPassword.length > 5 && this.newPassword == this.confirmNewPassword
    },
    title() {
      return window.location.hostname.split(".").splice(1).join(".")
    }
  },
  methods: {
    newPasswordOnClick() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.btnLoading = true
      this.axios.post("/login/resetpassword", {
        token: this.$route.query.token,
        password: this.confirmNewPassword,
      }).then(()=>{
        this.AuthNavigateTo('gotoLogin')
        this.ShowInfo("info", LoginStrings(this, "password_reset"))
      }).catch(()=> {
        this.ShowInfo("error", "Something Went Wrong")
      }).finally(() => {
        this.btnLoading = false
      })
    },
    cancelButtonOnClick() {
      this.AuthNavigateTo('gotoLogin')
    }
  }
}
</script>